import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import data from "../../../assets/apiRoutes.json";
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { GetFormatedDateWithTime, FormatPhoneNumber } from '../../../common/Utils'
import HeaderFrom from "../../common/HeaderFrom";
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import AddressTab from "../../common/AddressTab";
import AlternateAddressTab from "../../common/AlternateAddressTab";
import MasterDataTab from "../../common/MasterDataTab";
import Synonym from "../../common/Synonym";
import UserDefinedTab from "./tabs/UserDefinedTab";
import AdditionalTab from "./tabs/AdditionalTab";
import OMDefaultsTab from "./tabs/OMDefaultTab";
import WMDefaultTab from "./tabs/WMDefaultTab";

var skipDataLoading = false;

function CarrierForm(props) {

    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: new Date(),
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: new Date(),
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: 'ID',
        RECORDTYPE: 'R',
        IDENTITYID: '',
        NAME: '',
        R_DEFAULTADDRESS: null,
        INVISIBLETYPEGUID: '',
        R_PROFILE: null,
        PROFILEGUID: '',
        PROFILECODE: '',
        IDGROUP: '',
        IDSUBGROUP: '',
        REFERENCE1: '',
        REFERENCE2: '',
        DATE1: null,
        DATE2: null,
        R_CONTACT: null,
        COMMENT: '',
        R_IDENTITY: null,
        AddressROWID: '00000000-0000-0000-0000-000000000000',
        AddressCREATIONDATETIME: new Date(),
        AddressLASTUPDATEDATETIME: new Date(),
        AddressADDRESSNAME: '',
        AddressADDRESS1: '',
        AddressADDRESS2: '',
        AddressCITY: '',
        AddressZIP: '',
        AddressCOUNTRY: '',
        AddressTELEPHONE1: '',
        AddressTELEPHONE2: '',
        AddressFAX1: '',
        AddressFAX2: null,
        AddressMODEM1: '',
        AddressMODEM2: '',
        AddressCELLPHONE1: null,
        AddressCELLPHONE2: null,
        AddressPAGER1: null,
        AddressPAGER2: '',
        AddressEMAILADDRESS1: '',
        AddressEMAILADDRESS2: '',
        AddressWEBSITEADDRESS1: '',
        AddressWEBSITEADDRESS2: '',
        AddressSTATE: '',
        AddressALTERNATENAME: '',
        AddressLATITUDE: '',
        AddressLONGITUDE: '',
        AddressCOUNTY: '',
        AlterAddressROWID: '00000000-0000-0000-0000-000000000000',
        AlterAddressCREATIONDATETIME: new Date(),
        AlterAddressLASTUPDATEDATETIME: new Date(),
        AlterAddressNAME: '',
        AlterAddressADDRESSNAME: '',
        AlterAddressADDRESS1: '',
        AlterAddressADDRESS2: '',
        AlterAddressCITY: '',
        AlterAddressZIP: '',
        AlterAddressCOUNTRY: '',
        AlterAddressTELEPHONE1: '',
        AlterAddressTELEPHONE2: '',
        AlterAddressFAX1: '',
        AlterAddressFAX2: null,
        AlterAddressMODEM1: '',
        AlterAddressMODEM2: '',
        AlterAddressCELLPHONE1: null,
        AlterAddressCELLPHONE2: null,
        AlterAddressPAGER1: null,
        AlterAddressPAGER2: '',
        AlterAddressEMAILADDRESS1: '',
        AlterAddressEMAILADDRESS2: '',
        AlterAddressWEBSITEADDRESS1: '',
        AlterAddressWEBSITEADDRESS2: '',
        AlterAddressSTATE: '',
        AlterAddressALTERNATENAME: '',
        AlterAddressLATITUDE: '',
        AlterAddressLONGITUDE: '',
        AlterAddressCOUNTY: '',
        DefAddress: true,
        RECORD: '',
        IDTYPE:'05',
        CarrierROWID: '00000000-0000-0000-0000-000000000000',
        CarrierCREATIONDATETIME: new Date(),
        CarrierLASTUPDATEDATETIME: new Date(),
        CarrierCOMPANYID  :'',
        CarrierMODULE:'ID',
        CarrierRECORDTYPE:'R',
        CarrierUSERDEFINEDCODE_1:  null,
        CarrierUSERDEFINEDCODE_2:  null,
        CarrierUSERDEFINEDCODE_3:  null,
        CarrierUSERDEFINEDCODE_4:  null,
        CarrierUSERDEFINEDCODE_5:  null,
        CarrierUSERDEFINEDCODE_6:  null,
        CarrierUSERDEFINEDCODE_7:  null,
        CarrierUSERDEFINEDCODE_8:  null,
        CarrierUSERDEFINEDCODE_9:  null,
        CarrierUSERDEFINEDCODE_10: null,
        CarrierUSERDEFINEDDATE_1: null,
        CarrierUSERDEFINEDDATE_2: null,
        CarrierUSERDEFINEDDATE_3: null,
        CarrierUSERDEFINEDDATE_4: null,
        CarrierUSERDEFINEDDATE_5: null,
        CarrierUSERDEFINEDDATE_6: null,
        CarrierUSERDEFINEDDATE_7: null,
        CarrierUSERDEFINEDDATE_8: null,
        CarrierUSERDEFINEDDATE_9: null,
        CarrierUSERDEFINEDDATE_10: null,
        CarrierUSERDEFINEDQUANTITY_1: null,
        CarrierUSERDEFINEDQUANTITY_2: null,
        CarrierUSERDEFINEDQUANTITY_3: null,
        CarrierUSERDEFINEDQUANTITY_4: null,
        CarrierUSERDEFINEDQUANTITY_5: null,
        CarrierUSERDEFINEDQUANTITY_6: null,
        CarrierUSERDEFINEDQUANTITY_7: null,
        CarrierUSERDEFINEDQUANTITY_8: null,
        CarrierUSERDEFINEDQUANTITY_9: null,
        CarrierUSERDEFINEDQUANTITY_10: null,
        CarrierUSERDEFINEDREFERENCE_1: null,
        CarrierUSERDEFINEDREFERENCE_2: null,
        CarrierUSERDEFINEDREFERENCE_3: null,
        CarrierUSERDEFINEDREFERENCE_4: null,
        CarrierUSERDEFINEDREFERENCE_5: null,
        CarrierUSERDEFINEDREFERENCE_6: null,
        CarrierUSERDEFINEDREFERENCE_7: null,
        CarrierUSERDEFINEDREFERENCE_8: null,
        CarrierUSERDEFINEDREFERENCE_9: null,
        CarrierUSERDEFINEDREFERENCE_10:null,
        CarrierUSERDEFINEDCOMMENT: '',
        CarrierCOMMENT: null,
        CarrierSCACCODE: null,
        CarrierINSURANCEAMOUNT: null,
        CarrierINSURANCEEXPIRATION: null,
        CarrierPOPUPMESSAGE:null,
        CarrierSTATUS: 'A',
        CarrierR_TRADINGPARTNER: '',
        CarrierFREIGHTRATE: null,
        CarrierSHOWONWMWEB: 'Y',
        CarrierINTEGRATIONEXPORTTYPE: 'N'
     
    };
    
    const history = useHistory();
    const IdType ="05";
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await postCarrier();
            }
            else {
                await updateCarrier();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const postCarrier = async () => {
        try {
            const url = "id/Carrier/InsertCarrierDataEntry";
            let fields = formFields;
            fields.DefAddress = fields.DefAddress ?? true;
            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.CarrierINSURANCEEXPIRATION = GetFormatedDateWithTime(formFields.CarrierINSURANCEEXPIRATION);
            fields.RECORDTYPE = 'R';
            fields.CarrierUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_1);
            fields.CarrierUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_2);
            fields.CarrierUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_3);
            fields.CarrierUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_4);
            fields.CarrierUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_5);
            fields.CarrierUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_6);
            fields.CarrierUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_7);
            fields.CarrierUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_8);
            fields.CarrierUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_9);
            fields.CarrierUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_10);
            fields.IDTYPE='05';
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    RECORD: response.data.RECORD,
                    R_IDENTITY: response.data.ROWID,
                    AddressROWID: response.data.AddressROWID,
                    R_DEFAULTADDRESS: response.data.AddressROWID,
                    CarrierROWID: response.data.EntityROWID,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                notify(
                    {
                        message: "Carrier/Ship Via Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateCarrier = async () => {
        try {
            const url = "id/Carrier/UpdateCarrierDataEntry";
            let fields = formFields;
            fields.DefAddress = fields.DefAddress ?? true;
            if (fields.AlterAddressROWID === null)
                fields.AlterAddressROWID = initialFormFields.AlterAddressROWID;

            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.CarrierINSURANCEEXPIRATION = GetFormatedDateWithTime(formFields.CarrierINSURANCEEXPIRATION);
            fields.CarrierUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_1);
            fields.CarrierUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_2);
            fields.CarrierUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_3);
            fields.CarrierUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_4);
            fields.CarrierUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_5);
            fields.CarrierUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_6);
            fields.CarrierUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_7);
            fields.CarrierUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_8);
            fields.CarrierUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_9);
            fields.CarrierUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.CarrierUSERDEFINEDDATE_10);
            fields.IDTYPE = '05';

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                notify(
                    {
                        message: "Carrier/Ship Via Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad = (formRefs) => {
        primaryFormLoad(formRefs);
        additonalFormLookupsLoad(formRefs);
        wmDefaultsFormLookupsLoad(formRefs);
    }
    const userDefinedFormLookupsLoad = (formRefs) => {
       
    };
    const additonalFormLookupsLoad = (formRefs) => {
        loadLookupFromStaticData(formRefs, "CarrierSTATUS", [{ id: 'A', name: "Active" }, { id: 'I', name: "Inactive" }]);
        loadLookupFromStaticData(formRefs, "CarrierINTEGRATIONEXPORTTYPE", [{ id: 'N', name: "None" }, { id: 'U', name: "UPS" }, { id: 'F', name: "FedEx" } ]);

    };
    const primaryFormLoad = (formRefs) => {
  
        if (formRefs.current['RECORD']) {
            formRefs.current['RECORD'].instance().option('disabled', true);
        }
        
    }
    
    const omDefaultsFormLookupsLoad = (formRefs) => {
    }

    const wmDefaultsFormLookupsLoad = (formRefs) => {
        loadLookupFromStaticData(formRefs, "CarrierSHOWONWMWEB", [{ id: 'Y', name: "Show on WM Web" }, { id: 'N', name: "Do not show on WM Web" }]);
    }

    
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };
    
    const handleReset = () => {

        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };

    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.ID.DeleteCustomerDataEntry}`, formFields.ROWID, {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                });
                if (!response.data.ERRORS.length > 0) {
                    notify(
                        {
                            message: "Carrier/Ship Via Deleted",
                            width: 100,
                        },
                        'success',
                        3000,
                    );
                    setLoadPanelVisible(false);
                    history.push('/wm/codes/carrier-data-entry');
                } else {
                    setLoadPanelVisible(false);
                    const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
            }
        })
    }
    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/wm/codes/add-carrier');
        EnableControlsForNewRecord();
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/id/carrier/GetCarrierDataByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                if (responseData && responseData.ROWID) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                    if (formRefs.current["R_PROFILE"]) {
                        formRefs.current["R_PROFILE"].instance().option('disabled', true);
                    }
                }
                else {
                    console.error('Failed to get carrier/ship Via data');
                }
            });


        } catch (error) {
            console.error('Error failed to get carrier/ship via data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
    }, []);

    const goBack = () => {
        history.push("/wm/codes/carrier-data-entry");
    };

    const EnableControlsForNewRecord = () => {

        if (formRefs.current["R_PROFILE"]) {
            formRefs.current["R_PROFILE"].instance().option('disabled', false);
        }

    }

    const GetCarrierDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/id/Carrier/GetCarrierDataByProfileRowId?rowid=${profileId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                if (response.data) 
                {
                    let responseData = response.data
                    responseData.ROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.AddressROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.AlterAddressROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.CarrierROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.RECORD = '';
                    responseData.CREATIONDATETIME = null;
                    responseData.LASTUPDATEDATETIME = null;
                    responseData.AlterAddressCREATIONDATETIME = null;
                    responseData.AddressLASTUPDATEDATETIME = null;
                    responseData.AddressCREATIONDATETIME = null;
                    responseData.CarrierCREATIONDATETIME = null;
                    responseData.CarrierLASTUPDATEDATETIME = null;
                    responseData.CREATIONUSERID =  '';
                    responseData.LASTUPDATEUSERID =  '';
                    responseData.COMPANYID =  '';
                    responseData.MODULE =  'ID';
                    responseData.RECORDTYPE =  'R';
                    responseData.IDTYPE = "05";
                    setformFields(responseData);
                }
            }
            else {
                console.error('Failed to get carrier/ship via profile data');
            }
        } catch (error) {
            console.error('Error fetching carrier/ship via profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const handleFieldChange = useCallback((name, value, e) => {
        if (name == "R_PROFILE" && !skipDataLoading) {
            GetCarrierDataFromProfile(value);
        }
    });


    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                           Carrier/Ship Via Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel  showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <HeaderFrom formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} primaryFormLookupsLoad={primaryFormLookupsLoad} IdType={IdType}/>
                                </TabItem>
                                <TabItem title="Def Address" >
                                    <AddressTab formFields={formFields} setformFields={setformFields} />
                                </TabItem>
                                <TabItem title="Alternate Address" >
                                    <AlternateAddressTab formFields={formFields} setformFields={setformFields} IdType={IdType}/>
                                </TabItem>
                                <TabItem title="Additional">
                                <AdditionalTab formFields={formFields} setformFields={setformFields} additonalFormLookupsLoad={additonalFormLookupsLoad}/>
                                </TabItem>
                                <TabItem title="User Defined">
                                 <UserDefinedTab formFields={formFields} setformFields={setformFields} userDefinedFormLookupsLoad={userDefinedFormLookupsLoad}/>
                                </TabItem>
                                <TabItem title="OM Defaults">
                                     <OMDefaultsTab formFields={formFields} setformFields={setformFields} omDefaultsFormLookupsLoad={omDefaultsFormLookupsLoad} />
                                </TabItem>
                                <TabItem title="WM Defaults">
                                  <WMDefaultTab formFields={formFields} setformFields={setformFields} wmDefaultsFormLookupsLoad={wmDefaultsFormLookupsLoad}/>
                                </TabItem>
                                <TabItem title="Contact" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                    <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="Contact"
                                    gridKey='275C96CD-E464-45E9-9B41-95E084F83D26'/>
                                </TabItem>
                                <TabItem title="All Contacts" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                    <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="AllContacts" 
                                        gridKey='BCDFA379-D6D9-4B2F-8E9B-13896CE767EF'/>
                                </TabItem>
                                <TabItem title="Synonyms" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                    <Synonym  gridKey="F105A7EB-5B31-4E9D-9DD0-21FD290B4246" formFields={formFields} IdType={IdType}></Synonym>
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CarrierForm);
